module.exports = __webpack_public_path__ + "media/img/prod-1-8d2f9267.jpg";